import { AnswerLanguage } from '@glow/ai-contract'
import { FormSelectA11y } from '@glow/ui-components'
import i18next from 'i18next'
import { languageOptions } from '../../i18n/languageOptions'
import { answerLanguageOf } from './aiAnswerLanguage'

interface Props {
  language: AnswerLanguage
  onSelect: (language: AnswerLanguage) => void
}

export const AiLanguagePicker = ({ language, onSelect }: Props) => (
  <FormSelectA11y
    className="w-fit"
    alignMenu="right"
    aria-label={i18next.t('aiChat.language')}
    showNoneOption={false}
    selected={languageOptions.find((option) => answerLanguageOf(option.code) === language)?.code}
    options={languageOptions}
    onSelect={(code) => code !== undefined && onSelect(answerLanguageOf(String(code)))}
  />
)
